// Libraries
import React, { useContext } from 'react';
import { useMutation } from '@apollo/client';
import { Box, Modal, Button, Typography, Stack } from '@mui/material';

// Local
import { 
  DELETE_BOOKMARK, 
} from '../../../../Queries';
import { DocumentContext } from '../../../DocumentContext';
import { notify } from '../../../../Common/notify';
import { DELETE_MANUSCRIPT_LIBRARY } from '../../../../Queries'


const RemovePromptNoteLibrary = ({ paper, modal, setModal, paperInLibrary=true }) => {
  const context = useContext(DocumentContext);

 
  const [deleteManuscriptLibrary] = useMutation(DELETE_MANUSCRIPT_LIBRARY, {
    fetchPolicy: 'network-only'
  })

  const [deleteBookmark] = useMutation(DELETE_BOOKMARK, {
    fetchPolicy: 'network-only',
    variables: {
      id_value: paper.id_int.toString(),
    },
    onCompleted: ({ deleteBookmark }) => {
      if (deleteBookmark.status === 'success') {
        // Update search results and bookmarks
        const bookmarkID = deleteBookmark.response._id
        const removedPaperIdInt = context.bookmarks.find(bookmark => bookmark._id === bookmarkID).id_int

        const updatedBookmarks = context.bookmarks.filter(bookmark => bookmark.id_int !== removedPaperIdInt)
        context.updateContext('bookmarks', updatedBookmarks);

        if (paperInLibrary) {
          const updatedSearchResults = context.searchResults.filter(searchResult => searchResult.id_int !== removedPaperIdInt)
          context.updateContext('searchResults', updatedSearchResults);
        }



        deleteManuscriptLibrary({
          variables: {
            doc_id: context.documentId,
            bookmark_id: bookmarkID,
          },
          onCompleted: ({ deleteManuscriptLibrary }) => {
            if (deleteManuscriptLibrary.status === 'success') {
              const newNoteLibrary = deleteManuscriptLibrary.response.map(item => item);
              context.updateContext('manuscriptLibrary', newNoteLibrary);
              context.updateContext('loadingRequest', false);
              context.updateContext('loadingMessage', 'Removed library item');
            } else {
              notify(deleteManuscriptLibrary.message);
              context.updateContext('loadingRequest', false);
            }
          }
        })

      } else {
        notify(deleteBookmark.message);
        context.updateContext('loadingRequest', false);
        context.updateContext('loadingMessage', '');
      }
    },
  });

  return (
    <Modal
      aria-labelledby="Remove"
      aria-describedby="Remove library item"
      open={modal}
      onClose={() => setModal(false)}
      closeAfterTransition
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          height: 'auto',
          maxWidth: '400px',
          bgcolor: 'background.paper',
          color: 'text.primary',
          boxShadow: 24,
          p: 2,
        }}
      >
        <Typography
          sx={{
            textAlign: 'left',
            marginBottom: '10px',
          }}
        >
          {`Remove: ${paper.Title}`}
        </Typography>
        <Stack
          direction="row"
          spacing={1}
          sx={{
            justifyContent: 'flex-start',
          }}
        >
          <Button
            variant="outlined"
            onClick={async () => {
              context.updateContext('loadingRequest', true);
              context.updateContext('loadingMessage', 'Removing library item');

              setModal(false);
              deleteBookmark();
            }}
          >
            Remove
          </Button>
          <Button
            variant="outlined"
            onClick={() => {
              setModal(false);
            }}
          >
            Cancel
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default RemovePromptNoteLibrary;
